module.exports = __webpack_public_path__ + "img/1.afcfc5fc.png";